module.exports = __webpack_public_path__ + "img/logo-loto-hotpicks.4f2b5f27.jpg";